import { LoadingButton } from "@mui/lab";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  Select,
  Slide,
  styled,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import axios, { AxiosInstance } from "axios";
import React, {
  forwardRef,
  ReactElement,
  Ref,
  FC,
  useState,
  useEffect,
  Fragment,
} from "react";
import { ActionType, AlertType } from "../../../types/AlertType";
import CheckAttr from "../../../utils/CheckAttr";
import {
  IAssociationParametrage,
} from "../../content/parametrage/Operation/Operation";
import { IPays } from "../../content/parametrage/Pays/Pays";
import { cellStyle, urlApi } from "../../content/parametrage/Pays/RowPays";
import { Itarif } from "../../content/parametrage/Tarification/Tarification";
import { SnackBarAlert } from "../../element/SnackBarAlert";
import { useStyles } from "../styles";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import CheckIcon from "@mui/icons-material/Check";
import RowAddTarif from "./RowAddTarif";
import Cookies from "universal-cookie";
import { ConnectedUser } from "../../../utils/utils";
import { TarifInterface } from "../../content/parametrage/Tarification/InterfaceTarification";
import { DataRef } from "../../../types/DataRef";

import IconButton from "@mui/material/IconButton";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { ArticleInterface } from "../../content/parametrage/Article/InterfaceArticle";

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: ReactElement<any, any>;
  },
  ref: Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const StyledTableCellArticle = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#080d44",
    color: theme.palette.common.white,
    textAlign: "left",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    textAlign: "left",
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    textAlign: "left",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    textAlign: "left",
  },
}));

const AddtarifForms: FC<IAddTarifFormsProps> = ({
  dataRefPaysBu,
  rowtarifToUpdate,
  getPaginateTarif,
  onClose,
}) => {
  const classes = useStyles();

  const resetValueTarif: ITarifToSave = {
    arrayTarifRow: [],
    date_debut: undefined,
    date_fin: undefined,
  };

  // Selected
  const [paysSelected, setPaysSelected] = useState<IPays>();
  const [clientSelected, setClientSelected] = useState<DataRef>();
  const [operationSelected, setOperationSelected] =
    useState<OperationInterfaceWith>();

  const [dateDebut, setDateDebut] = useState<Date>(
  );
  const [dateFin, setDateFin] = useState<Date>(
  );
  /*const [associationSelected, setAssociationSelected] =
    useState<IAssociationParametrage>();*/
  // Selected

  const [tarifToSave, setTarifToSave] = useState<ITarifToSave>(resetValueTarif);

  // data All
  const [allTarifSiExiste, setAllTarifSiExiste] = useState<TarifInterface[]>(
    []
  );
  const [alltarrifGB, setAllTarifGb] = useState([]);
  const [allAssociationByPaysBu, setAllAssociationByPaysBu] = useState<
    IAssociationParametrage[]
  >([]);
  const [allClient, setAllClient] = useState<DataRef[]>([]);
  const [allOperation, setAllOperation] = useState<OperationInterfaceWith[]>(
    []
  );

  const [allArticle, setAllArticle] = useState<ArticleInterface[]>([]);

  // Autre

  const [alertType, setAlertType] = useState<AlertType>("success");
  const [alertMessage, setAlerteMessage] = useState<string>("");
  const [openSnack, setOpenSnack] = useState<boolean>(false);
  const [openModalConfirmation, setOpenModalConfirmation] =
    useState<boolean>(false);
  const [loaderButton, setLoaderButton] = useState<boolean>(false);
  const [open, setOpen] = useState(true);
  const cookies = new Cookies();
  const token: string = cookies.get("jwt");
  const [refresh, setRefrech] = useState<boolean>(true);
  const [errorInput, setErrorInput] =
    useState<InputValidation>(resetInpuValidation);

  // Autre
  const [loader, setLoader] = useState<boolean>(false);

  const logger = ConnectedUser();

  const http: AxiosInstance = axios.create({
    baseURL: urlApi,
    // timeout: 1000,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const getClientByPays = (payId: any) => {
    axios
      .get(`${urlApi}client/get/by/paysid/${payId}`, {
        /* headers: {
            Authorization: `Bearer ${user.token}`,
          },*/
      })
      .then((res) => {
        setAllClient(res.data);
      })
      .finally(() => { });
  };

  const getOperationByClient = (idClient: any) => {
    http
      .get(`operation/get/by/client/${idClient}`)
      .then((res) => {
        setAllOperation(res.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => { });
  };

  const getTarifInDate = () => {
    setLoader(true);
    const data = {
      idPays: paysSelected?.id,
      idClient: clientSelected?.id,
      operation_id: operationSelected?.id,
      dateDebut: dateDebut,
      dateFin: dateFin,
    };

    axios
      .post(`${urlApi}get/tarification`, data, {
        /* headers: {
        Authorization: `Bearer ${user.token}`,
      },*/
      })
      .then((res) => {
        setAllTarifSiExiste(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const getAllArticle = (data: any) => {
    http
      .post("get/articles", data)
      .then((res) => {
        setAllArticle(res.data.data);
        console.log(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
      });
  };


  useEffect(() => {
    paysSelected?.id !== undefined &&
      // associationSelected?.client?.id !== undefined &&
      dateDebut !== undefined &&
      dateFin !== undefined &&
      clientSelected?.id !== undefined &&
      operationSelected?.id !== undefined &&
      getTarifInDate();

    const data = {
      idPays: paysSelected?.id,
      operation_id: operationSelected?.id,
    };

    paysSelected?.id !== undefined &&
      clientSelected?.id !== undefined &&
      operationSelected?.id !== undefined &&
      getAllArticle(data);
  }, [
    paysSelected?.id,
    clientSelected?.id,
    operationSelected?.id,
    // associationSelected?.client?.id,
    dateDebut,
    dateFin,
  ]);

  const handleChangeTarif = (tarifRow: TarifInterface, action: ActionType) => {
    let defaulttarif: TarifInterface[] = tarifToSave?.arrayTarifRow as TarifInterface[];

    console.log(tarifRow);
    if (action === "CREATE") {
      defaulttarif.push(tarifRow as TarifInterface);
    }

    if (action === "UPDATE") {
      const index = defaulttarif.findIndex(
        (c) => c.article_id === tarifRow.article_id
      );

      defaulttarif[index] = tarifRow;
    }

    setTarifToSave({
      ...tarifToSave,
      arrayTarifRow: defaulttarif,
    });
  };


  const handleChange = (e: any) => {
    const { name, value } = e.target;

    if (name === "pays") {
      setPaysSelected(dataRefPaysBu.find((x) => x.id == value) as IPays);
      setClientSelected(allClient.find((x) => x.id == 0));
      setOperationSelected(allOperation?.find((x) => x.id == 0));
      setAllTarifSiExiste([]);

      // setAssociationSelected(allAssociationByPaysBu?.find((x) => x.id == 0));
      getClientByPays(value);
    }

    if (name === "client") {
      setClientSelected(allClient.find((x) => x.id == value));
      setOperationSelected(allOperation?.find((x) => x.id == 0));
      setAllTarifSiExiste([]);
      // const allAsoTemp = allAssociationByPaysBu?.find((x) => x.id == value);
      // setAssociationSelected(allAsoTemp);

      // Teste si Aucune Client
      /* if (allAsoTemp?.operations?.length == 0) {
        setAlertType("warning");
        setAlerteMessage(`Il y a aucune operation`);
        setOpenSnack(true);
      }*/



      getOperationByClient(value);

      setTarifToSave({ ...tarifToSave, arrayTarifRow: [] });
    }

    if (name === "Operation") {
      setOperationSelected(allOperation?.find((x) => x.id == value));
      const data = {
        idPays: paysSelected?.id,
        operation_id: value,
      };
      // getAllArticle(data);
    }

    if (name === "date_debut") {
      setDateDebut(value);
      setTarifToSave({
        ...tarifToSave,
        date_debut: value,
      });
    }

    if (name === "date_fin") {
      setDateFin(value);
      setTarifToSave({
        ...tarifToSave,
        date_fin: value,
      });
    }
  };

  const isValidate = (): boolean => {
    // Reinitialise les variables des validations
    setErrorInput(resetInpuValidation);
    let tabTarifToModifier: Number[] = [];

    // Les Tarifs deja Creer
    console.log(allTarifSiExiste);

    // Teste Si Tous les operation sont deja parametre
    const arrayIdTarifDejaCreer = allTarifSiExiste?.map((t) => t.article_id);
    console.log(arrayIdTarifDejaCreer);
    console.log(tarifToSave?.arrayTarifRow);
    const operationTarifToModifier = tarifToSave?.arrayTarifRow?.filter(
      (tarifRow) => !arrayIdTarifDejaCreer.includes(tarifRow?.article_id)
    );
    console.log(operationTarifToModifier);

    if (operationTarifToModifier?.length == 0) {
      // Tous les operation sont deja parametre
      setAlerteMessage(
        "Merci de saisir des tarifs pour une nouvelle période SVP"
      );
      setAlertType("warning");
      setOpenSnack(true);

      return false;
    }

    // teste Au moins un nvl tarif sont Parametre
    const arrayCheckAttr = operationTarifToModifier?.map((x) =>
      CheckAttr(x?.tarifacte) || CheckAttr(x?.tarifheure) ? true : false
    );
    console.log(arrayCheckAttr);
    const isAllFalse = arrayCheckAttr?.reduce(
      (acc, value) => acc && !value,
      true
    );
    console.log(isAllFalse);
    tarifToSave?.arrayTarifRow?.map((tarifTemp) => {
      if (
        !CheckAttr(tarifTemp?.tarifacte) &&
        !CheckAttr(tarifTemp?.tarifheure)
      ) {
        // tabTarifToModifier.push(tarifTemp?.idOperation);
      }
    });

    setErrorInput((prev: InputValidation) => ({
      ...prev,
      tarif: tabTarifToModifier,
    }));

    if (isAllFalse) {
      setAlerteMessage(
        "Merci de paramétrer au moins un article parmi ceux qui n’ont pas encore de tarif SVP"
      );
      setAlertType("warning");
      setOpenSnack(true);
      return false;
    }
    if (
      !CheckAttr(paysSelected?.id) ||
      !CheckAttr(dateDebut) ||
      !CheckAttr(dateFin) ||
      tabTarifToModifier.length !== 0
    ) {
      /*if (!CheckAttr(associationSelected?.id)) {
        setErrorInput((prev: InputValidation) => ({
          ...prev,
          associationSelected: true,
        }));
      }*/

      if (!CheckAttr(paysSelected?.id)) {
        setErrorInput((prev: InputValidation) => ({
          ...prev,
          paysSelected: true,
        }));
      }

      if (!CheckAttr(operationSelected?.id)) {
        setErrorInput((prev: InputValidation) => ({
          ...prev,
          operationSelected: true,
        }));
      }

      if (!CheckAttr(dateDebut)) {
        setErrorInput((prev: InputValidation) => ({
          ...prev,
          dateDebut: true,
        }));
      }

      if (!CheckAttr(dateFin)) {
        setErrorInput((prev: InputValidation) => ({ ...prev, dateFin: true }));
      }

      if (!CheckAttr(dateFin)) {
        setErrorInput((prev: InputValidation) => ({ ...prev, dateFin: true }));
      }

      setAlerteMessage("Merci de remplir les champs en obligatoire !");
      setAlertType("warning");
      setOpenSnack(true);

      return false;
    }
    return true;
  };
  const saveTarificationSansCondition = () => {
    setLoaderButton(true);
    tarifToSaveFunc()?.map((ItarifOperationSave, index) => {
      const data = {
        operationId: ItarifOperationSave?.article_id,
        dateDebut: dateDebut,
        dateFin: dateFin,
        tarifActe: ItarifOperationSave?.tarifacte,
        tarifHeure: ItarifOperationSave?.tarifheure,
      };
      axios
        .post(`${urlApi}create/tarification`, data)
        .then((res) => {
          if (typeof res.data == "string") {
            setAlertType("warning");
            setAlerteMessage(res.data);
            setOpenSnack(true);
          } else {
            // Recharger la Page (Insert avec success)
            setAlertType("warning");
            setAlerteMessage(res.data.message);
            setOpenSnack(true);
            onClose();
            getPaginateTarif();
            if ((tarifToSave?.arrayTarifRow?.length as number) - 1 == index) {
              onClose();
              getPaginateTarif();
            }
          }
        })
        .finally(() => {
          //setLoader(false);
          setLoaderButton(false);
        });
    });
  };

  console.log(allOperation);

  const tarifToSaveFunc = () => {
    console.log(allTarifSiExiste);
    const arrayIdTarifDejaCreer = allTarifSiExiste?.map((t) => t.article_id);
    console.log(arrayIdTarifDejaCreer);
    console.log(tarifToSave?.arrayTarifRow);
    const operationTarifToModifier = tarifToSave?.arrayTarifRow?.filter(
      (tarifRow) => !arrayIdTarifDejaCreer.includes(tarifRow?.article_id)
    );
    console.log(operationTarifToModifier);

    // teste Au moins un tarif
    console.log(tarifToSave.arrayTarifRow);

    const TarifToAdd = operationTarifToModifier?.filter(
      (x) => CheckAttr(x?.tarifacte) || CheckAttr(x?.tarifheure)
    );
    console.log(TarifToAdd);
    return TarifToAdd;
  };
  const handleSave = () => {
    if (isValidate()) {
      // Teste De chevauchement de tout les tarif operation
      const dataToChevauchementTemp = {
        dateDebut: tarifToSave.date_debut,
        dateFin: tarifToSave.date_fin,
        arrayIdOperation: tarifToSaveFunc(),
        type: "tarif",
        user: logger?.id,
      };
      // setLoaderButton(true);

      http
        .post("check/chevauchement", dataToChevauchementTemp)
        .then((res) => {
          if (res.data.length == 0) {
            // Pas de chevauchement alors Insert
            saveTarificationSansCondition();
          } else {
            // Il y a un chevauchement
            setAlertType("warning");
            setAlerteMessage(
              `Il y a déjà un tarif paramétré pour l’opération "${res.data[0].operation.libelle}" à l’intervalle de date saisi`
            );
            setOpenSnack(true);
            setLoaderButton(false);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => { });
    }
  };

  const handleCloseAlert = () => {
    setOpenSnack(false);
  };

  const stackAlert: JSX.Element = SnackBarAlert(
    openSnack,
    handleCloseAlert,
    alertType,
    alertMessage
  );

  return (
    <Fragment>
      {stackAlert}
      <Box
        sx={
          {
            // Width: '100%',
          }
        }
      >
        <Grid container spacing={2} columns={{ xs: 6, sm: 12, md: 4 }}>
          <Grid item xs={6} sm={6} md={2}>
            <FormControl
              variant="outlined"
              className={classes.formControl}
              sx={{ marginLeft: 1, marginTop: 1 }}
            >
              <InputLabel
                htmlFor="pays"
                color="warning"
              // shrink={CheckAttr(saisieAgentToSave?.pays)}
              >
                Pays De Production
              </InputLabel>
              <Select
                id="pays"
                native
                color="warning"
                disabled={rowtarifToUpdate?.id ? true : false}
                error={errorInput.paysSelected}
                value={paysSelected?.id}
                onChange={handleChange}
                label="Pays"
                inputProps={{
                  name: "pays",
                }}
              >
                <option value=""></option>
                {dataRefPaysBu.map((pays) => (
                  <option key={pays?.id} value={pays?.id}>
                    {pays?.libelle}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={6} md={2}>
            <FormControl
              variant="outlined"
              className={classes.formControl}
              sx={{ marginLeft: 1, marginTop: 1 }}
            >
              <InputLabel
                htmlFor="client"
                color="warning"
              // shrink={CheckAttr(associationSelected?.id)}
              >
                Client
              </InputLabel>
              <Select
                id="client"
                native
                color="warning"
                /*disabled={disable}*/
                error={errorInput.associationSelected}
                value={clientSelected?.id !== undefined ? clientSelected?.id : ""}
                onChange={handleChange}
                label="Client"
                inputProps={{
                  name: "client",
                }}
              >
                <option value=""></option>
                {allClient.map((cl) => (
                  <option key={cl?.id} value={cl?.id}>
                    {cl?.libelle}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={6} md={2}>
            <FormControl
              variant="outlined"
              className={classes.formControl}
              sx={{ marginLeft: 1, marginTop: 1 }}
            >
              <InputLabel
                htmlFor="client"
                color="warning"
              // shrink={CheckAttr(associationSelected?.id)}
              >
                Operation
              </InputLabel>
              <Select
                id="client"
                native
                color="warning"
                /*disabled={disable}*/
                error={errorInput.associationSelected}
                value={operationSelected?.id !== undefined ? operationSelected?.id : ""}
                onChange={handleChange}
                label="Operation"
                inputProps={{
                  name: "Operation",
                }}
              >
                <option value=""></option>
                {allOperation.map((op) => (
                  <option key={op?.id} value={op?.id}>
                    {op?.libelle}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={6} md={2}></Grid>
          <Grid item xs={6} sm={6} md={2}>
            <TextField
              disabled={rowtarifToUpdate?.id ? true : false}
              name="date_debut"
              label="Date debut"
              type="date"
              color="warning"
              fullWidth
              /*disabled={disable}*/
              error={errorInput.dateDebut}
              value={dateDebut}
              onChange={handleChange}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={2}>
            <TextField
              name="date_fin"
              label="Date Fin"
              type="date"
              color="warning"
              fullWidth
              /*disabled={disable}*/
              error={errorInput.dateFin}
              value={dateFin}
              onChange={handleChange}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        </Grid>
        {
          // associationSelected?.operations?.length &&
          dateDebut && dateFin && (
            <>
              <TableContainer sx={{ mt: 4 }}>
                <Table sx={{ minWidth: 700 }} aria-label="customized table">
                  <TableHead >
                    <TableRow sx={{ backgroundColor: "#080d24" }}>
                      <StyledTableCell sx={{ backgroundColor: "white" }}>Societe facturation</StyledTableCell>
                      <StyledTableCell sx={{ backgroundColor: "white" }}>Code Gesco</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {/*allTarifSiExiste !== undefined &&
                      associationSelected?.operations?.map((operationRow) => (
                        <RowAddTarif
                          associationSelected={associationSelected}
                          rowOperationDuClient={operationRow}
                          handleChangeTarif={handleChangeTarif}
                          idOperationSansTarif={errorInput?.tarif}
                          rowTarifSiExiste={allTarifSiExiste}
                          refresh={refresh}
                        />
                      ))*/}
                    {operationSelected?.pivot_oper_socifact_code_gesco
                      ?.filter((pivot) => (pivot?.articles?.length !== 0))
                      .map((pivot) => (
                        pivot?.articles?.filter((art) => (allArticle?.map((artA) => artA.id).includes(art.id))).length !== 0 &&

                        <>
                          <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
                            <TableCell component="th" scope="row">
                              <IconButton
                                aria-label="expand row"
                                size="small"
                                onClick={() => setOpen(!open)}
                                sx={{ fontSize: 12 }}
                              >
                                {open ? (
                                  <KeyboardArrowUpIcon />
                                ) : (
                                  <KeyboardArrowDownIcon />
                                )}
                              </IconButton>
                              {
                                pivot?.piv_societe_fact_code
                                  ?.societe_facturation?.libelle
                              }
                            </TableCell>
                            <TableCell component="th" scope="row">
                              {
                                pivot?.piv_societe_fact_code?.code_gesco
                                  ?.libelle
                              }
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell style={cellStyle} colSpan={2}>
                              <Collapse in={open} timeout="auto" unmountOnExit>
                                <Box>
                                  <Table size="small" aria-label="purchases">
                                    <TableHead>
                                      <TableRow>
                                        <StyledTableCellArticle
                                          style={cellStyle}
                                          align="center"
                                        >
                                          Code Article
                                        </StyledTableCellArticle>
                                        <StyledTableCellArticle
                                          style={cellStyle}
                                          align="center"
                                        >
                                          Désignation
                                        </StyledTableCellArticle>

                                        <StyledTableCellArticle
                                          style={cellStyle}
                                          align="center"
                                        >
                                          Tarif heure
                                        </StyledTableCellArticle>

                                        <StyledTableCellArticle
                                          style={cellStyle}
                                          align="center"
                                        >
                                          Tarif Acte
                                        </StyledTableCellArticle>
                                        <StyledTableCellArticle
                                          style={cellStyle}
                                          align="center"
                                        >
                                          Devise
                                        </StyledTableCellArticle>

                                        <StyledTableCellArticle
                                          style={cellStyle}
                                          align="center"
                                        >
                                          Date début
                                        </StyledTableCellArticle>

                                        <StyledTableCellArticle
                                          style={cellStyle}
                                          align="center"
                                        >
                                          Date de Fin
                                        </StyledTableCellArticle>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {
                                        // Fitre Tous lEs Article En Relation avec le Pays
                                        pivot?.articles?.filter((art) => (allArticle?.map((artA) => artA.id).includes(art.id))).map((rowArticle) => (
                                          <RowAddTarif
                                            handleChangeTarif={handleChangeTarif}
                                            rowArticle={rowArticle}
                                            operationSelected={operationSelected}
                                            rowTarifSiExiste={allTarifSiExiste}
                                          />
                                        ))}
                                    </TableBody>
                                  </Table>
                                </Box>
                              </Collapse>
                            </TableCell>
                            <TableCell style={cellStyle}></TableCell>
                          </TableRow>
                        </>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <Box display="flex" justifyContent="center" mt={5}>
                <LoadingButton
                  onClick={() => handleSave()}
                  endIcon={
                    rowtarifToUpdate?.id ? (
                      <BorderColorIcon />
                    ) : (
                      <PersonAddIcon />
                    )
                  }
                  // loading={isClickSave}
                  loading={loaderButton}
                  loadingPosition="end"
                  sx={{ textTransform: "none" }}
                  variant="contained"
                  color="warning"
                >
                  {rowtarifToUpdate?.id ? "Enregistrer" : "Ajouter"}
                </LoadingButton>
              </Box>
            </>
          )
        }
      </Box>
      <Dialog
        open={openModalConfirmation}
        TransitionComponent={Transition}
        keepMounted
        onClose={(e) => setOpenModalConfirmation(false)}
        aria-describedby="alert-dialog-slide-description"
        maxWidth="xs"
      >
        <DialogTitle>{"Confirmation"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {alertMessage}
            <br />
            <br />
            Voulez-vous continuer ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <LoadingButton
            onClick={() => saveTarificationSansCondition()}
            endIcon={<CheckIcon />}
            loadingPosition="end"
            sx={{ textTransform: "none" }}
            variant="contained"
            color="warning"
            loading={loaderButton}
            size="small"
          >
            Oui
          </LoadingButton>
          <Button
            onClick={(e) => setOpenModalConfirmation(false)}
            variant="contained"
            color="inherit"
            sx={{ textTransform: "none" }}
            startIcon={<ExitToAppIcon />}
            size="small"
          >
            Non
          </Button>
        </DialogActions>
      </Dialog>

      <div>
        <Backdrop
          sx={{ color: "white", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loader}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>

    </Fragment>
  );
};

export default AddtarifForms;

export interface ITarifRef {
  idOperation: number;
  tarifActe: string;
  tarifheure: string;
}

interface ITarifToSave {
  date_debut?: Date;
  date_fin?: Date;

  arrayTarifRow?: TarifInterface[];
}

interface IAddTarifFormsProps {
  dataRefPaysBu: IPays[];
  rowtarifToUpdate?: TarifInterface;
  getPaginateTarif: () => void;
  onClose: () => void;
}

interface InputValidation {
  associationSelected: boolean;
  paysSelected: boolean;
  operationSelected: boolean;
  dateDebut: boolean;
  dateFin: boolean;
  tarif: Number[];
}

interface Bus {
  id: number;
  libelle: string;
  created_at: string;
  updated_at: string;
  date_suppression: any;
}

const resetInpuValidation: InputValidation = {
  associationSelected: false,
  paysSelected: false,
  operationSelected: false,
  dateDebut: false,
  dateFin: false,
  tarif: [],
};

export interface OperationInterfaceWith {
  id: number;
  libelle: string;
  clients_id: number;
  date_suppression: any;
  pivot_oper_socifact_code_gesco: PivotOperSocifactCodeGesco[];
}

interface PivotOperSocifactCodeGesco {
  id: number;
  operation_id: number;
  piv_socifact_code_id: number;
  piv_societe_fact_code: PivSocieteFactCode;
  articles: Article[];
}

export interface PivSocieteFactCode {
  id: number;
  code_gesco_id: number;
  societe_facturation_id: number;
  societe_facturation: SocieteFacturation;
  code_gesco: CodeGesco;
}

interface SocieteFacturation {
  id: number;
  libelle: string;
  activite: any;
  forme_juridique: any;
  capital: any;
  adresse: any;
  code_postal: any;
  ville: any;
  registre_commerce: any;
  identifiant_fiscal: any;
  code: any;
  created_at: string;
  updated_at: any;
  date_suppression: any;
}

interface CodeGesco {
  id: number;
  libelle: string;
  intituleTiers: any;
  code_gesco_sage_id: any;
  created_at: string;
  updated_at: any;
  date_suppression: any;
}

export interface Article {
  id: number;
  actif: boolean;
  libelle: string;
  idOperationIrm: any;
  idSocieteFacturation: any;
  activite_id: any;
  type_id: any;
  piv_oper_socifact_codes_id: number;
  code_article_id: number;
  association_parametrage_id: number;
  devise_id: number;
  date_suppression: any;
  created_at: any;
  updated_at: any;
  devise: Devise
  code_article: CodeArticle
}

interface Devise {
  id: number
  monnaie: string
  symbole: string
  code_iso: string
  created_at: any
  updated_at: any
}

interface CodeArticle {
  id: number
  libelleCodeArticle: string
  code_article_sage_id: any
  created_at: string
  updated_at: string
  date_suppression: any
}
